import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 21l18 -18","key":"svg-0"}],["path",{"d":"M15 14l3 4.5","key":"svg-1"}],["path",{"d":"M21 14l-4.5 7","key":"svg-2"}],["path",{"d":"M3 4l6 6","key":"svg-3"}],["path",{"d":"M3 10l6 -6","key":"svg-4"}]]

const IconMathXDivideY2 = createReactComponent('outline', 'math-x-divide-y-2', 'MathXDivideY2', __iconNode);

export default IconMathXDivideY2;